@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.SpaceAssetTypeBadge {
  @extend %font-family-primary;

  font-size: $font-size-normal;
  font-weight: $font-weight-semibold;
  color: $theme-color-text;
  padding: 4px 6px;
  border-radius: 6px;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  column-gap: 6px;
  line-height: 18px;
  max-width: 296px;

  // override reacticons
  > svg {
    color: $theme-filter-icon-color;

    // override Icons
    path[fill] {
      fill: $theme-filter-icon-color;
    }
  }

  &.DefaultBackground {
    background: $theme-statuschip-ignore-background;
  }

  &.ConflictedBackground {
    background: $color-warning-orange-5;
  }

  .badgeWrapper {
    display: flex;
    align-items: center;
    column-gap: 6px;

    svg {
      fill: $color-warning-orange;
    }

    .errorIcon {
      fill: $theme-color-error-icon;
    }
  }
}
